import { useEffect, useState } from 'react';

import { CircularProgress } from '@mui/material';

import { KaseApi } from '@/api';
import { IArrestToolRow } from '@/api/api.arrests';
import { KaseProvider } from '@/contexts/KaseContext';
import { StubTabLayoutContextProvider } from '@/layouts/TabLayout';
import { IArrestee, IKase } from '@/models';
import KaseArrestEdit from '@/pages/Kases/KaseArrests/components/KaseArrestEdit/KaseArrestEdit';
import { KaseArrestsContextProvider } from '@/pages/Kases/KaseArrests/KaseArrestsContext';

import { ArrestNavigation } from './ArrestsToolArrestModal';

interface Props {
  row: IArrestToolRow;
  initialEditMode: boolean;
  onBack: () => void;
  inModal?: boolean;
  navigation?: ArrestNavigation;
}

export const ArrestsToolArrestScreen = ({
  row,
  initialEditMode,
  onBack,
  inModal,
  navigation,
}: Props) => {
  const [kase, setKase] = useState<IKase | null>(null);
  const [arrestee, setArrestee] = useState<IArrestee | null>(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      if (!row.kase?._id) return;
      const [kaseRes, arresteeRes] = await Promise.all([
        KaseApi.getOne(row.kase._id),
        KaseApi.getArrestee(row.kase._id, String(row.masterName)),
      ]);
      if (cancelled) return;
      setKase(kaseRes.data);
      setArrestee(arresteeRes.data);
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [row.kase?._id, row.masterName]);

  if (!kase || !arrestee) {
    return (
      <div className="flex h-[60vh] items-center justify-center">
        <CircularProgress />
      </div>
    );
  }

  return (
    <StubTabLayoutContextProvider>
      <KaseProvider initialKase={kase}>
        <KaseArrestsContextProvider
          nextRoutes={[]}
          initialArrestee={arrestee}
          initialEditMode={initialEditMode}
        >
          <KaseArrestEdit
            kaseIdProp={kase._id}
            onBack={onBack}
            inModal={inModal}
            navigation={navigation}
          />
        </KaseArrestsContextProvider>
      </KaseProvider>
    </StubTabLayoutContextProvider>
  );
};

export default ArrestsToolArrestScreen;
